import { ethers } from 'ethers';
export const config={
    137:{
        'name':'POL',
        'chainId':'0x89',
        'getTransactionUrl': (txHash) => `https://polygonscan.com/tx/${txHash}`,
        'provider': new ethers.AlchemyProvider(137, process.env.REACT_APP_ALCHEMY_KEY),
        'pools':[
            {
                name:'WBTC',
                address:'0x0C8Cb06a6F163B711866289C6A48604b19Aa367D',
                token:'0x1BFD67037B42Cf73acF2047067bd4F2C47D9BfD6',
                poolToken:'0x946B85C105456d1a9Bc8C0e9180653d01905D78E',
                poolTokenSymbol: 'WBTC.bbw',
                native: false,
                ticketPrice: 0.00001,
                decimals: 8,
                displayDecimals: 5
            },
            {
                name:'WETH',
                address:'0xca0ab29b953f7b10f4B6B5eDeB5D2060E677A6a6',
                poolToken:'0x7f9B1Bb2ebe904b314c0D10f623A27a9D2d983aF',
                token:'0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619',
                poolTokenSymbol: 'WETH.bbw',
                native: false,
                ticketPrice: 0.001,
                decimals: 18,
                displayDecimals: 3
            },
            {
                name:'POL',
                address:'0xD202EAe0F1D6460c26cBa193B3B40A67b012cDcA',
                poolToken:'0x70b9e72925Bd897990847dbFE526fbfB30f1d7fD',
                poolTokenSymbol: 'POL.bbw',
                native: true,
                ticketPrice: 1,
                decimals: 18,
                displayDecimals: 3
            },
            {
                name:'USDT',
                address:'0xE78071113B543C48578Dba7DCAFD35536Daca1C0',
                token:'0xc2132D05D31c914a87C6611C10748AEb04B58e8F',
                poolToken:'0x99bA5c133A1A853977E8295EAF82037523F5294D',
                poolTokenSymbol: 'USDT.bbw',
                zeroAllowance: false,
                ticketPrice: 1,
                decimals: 6,
                displayDecimals: 2
            }
        ]
    },
    0: {
        'name': 'ETH',
        'chainId': '0x1',
        'provider': new ethers.AlchemyProvider(1, process.env.REACT_APP_ALCHEMY_KEY),
        'getTransactionUrl': (txHash) => `https://etherscan.io/tx/${txHash}`,
        'pools': []
    }
}